import React from 'react';
import "./index.scss"
import { ReactComponent as ContactImage } from '../../assets/image-contact.svg';
import qrCode from '../../assets/qr-code.png'; // Import the image

const ContactPage = () => {
    return <div className={"contact-page"}>
        <ContactImage className={"image-contact"}/>
        <div className={'context'}>
            <div className={"texts"}>联系方式</div>
            <img src={qrCode} alt="QR Code" className={'qr-code'}/>
        </div>
    </div>
}

export default ContactPage;